import { useState } from "react";
import img from "../../assets/images/main-page/doctor-with-patient.jpg";

const Introduction = ({ aboutUsData }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <section className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12  pb-4
        md:py-6">
      {/* تصویر */}
      <div className="w-full lg:w-2/5 relative group">
        <div className="absolute inset-0  rounded-3xl transition-opacity duration-500 group-hover:opacity-0" />

        <img
          src={img}
          alt="دکتر و بیمار در مدیزن"
          className="w-full h-[150px] lg:h-[270px] object-cover rounded-3xl shadow-lg transition-transform duration-500 group-hover:scale-[1.02]"
        />
      </div>

      {/* متن */}
      <div className="w-full lg:w-3/5">
        <div className="flex justify-center items-center mb-2">
          <h3 className="flex items-center gap-2 w-full font-semibold text-[#383838]">
            <span className="flex items-center whitespace-nowrap  text-[17px] md:text-[22px]">
              <span className="text-[#383838]">با </span>
              <span className="text-purple mx-1.5">مدیزن</span>
              <span className="text-[#383838] ml-1.5">آشنا شوید</span>
            </span>
            <span className="flex-1 h-[2px] rounded-full bg-gradient-to-l from-purple/10 to-transparent"></span>
          </h3>
        </div>

        <div className="relative">
          <div
            className={`
              text-gray-600
              text-[13px]
              md:text-[14px]
              lg:text-[14.5px]
              leading-6
              lg:leading-7
              text-justify
              space-y-2
              overflow-hidden
              transition-all
              duration-700
              ${
                expanded
                  ? "max-h-[1000px]"
                  : "max-h-[112px] lg:max-h-none fade-text"
              }
            `}
          >
            <p>{aboutUsData.desc}</p>

            <p className="text-gray-500">
              {aboutUsData.moreDesc}
            </p>
          </div>

          {!expanded && (
            <button
              onClick={() => setExpanded(true)}
              className="
              lg:hidden
              absolute
              -bottom-[13px]
              right-0
              translate-y-1/2
              py-1.5
              rounded-full
              text-gray-700
              text-xs
              font-medium
              shadow-xs
              transition-all
              duration-300
              "
            >
              مشاهده بیشتر
            </button>
          )}
        </div>

        {expanded && (
          <button
            onClick={() => setExpanded(false)}
            className="
            lg:hidden
            mt-2
              text-gray-700
              text-xs
              font-medium
            hover:underline
            "
          >
            بستن
          </button>
        )}
      </div>
    </section>
  );
};

export default Introduction;